import moment from 'moment';
import _ from 'underscore';

export function dateParams(displayedDates) {
  return _.chain(displayedDates)
    .pick('start', 'finish')
    .map((date, key) => [key, moment(date).format()])
    .object()
    .value();
}
